module.exports = __webpack_public_path__ + "videos/selection_jp.94645ee.mp4";